/**
 * CloudBase Web SDK 单例（S04）。
 *
 * init 参数来自 Vite 环境变量（VITE_ 前缀，前端可见，只能放 Publishable Key，严禁放服务端 API Key）。
 * auth 采用 v3 Supabase 风格 API：getSession/getUser/signInWithOtp/data.verifyOtp/onAuthStateChange。
 */

import cloudbase from "@cloudbase/js-sdk";

const env = import.meta.env.VITE_TCB_ENV_ID as string;
const region = (import.meta.env.VITE_TCB_REGION as string) || "ap-shanghai";
const accessKey = import.meta.env.VITE_PUBLISHABLE_KEY as string;

if (!env || !accessKey) {
  // 不抛异常，让登录页给出可读提示（缺配置时本地开发常见）
  console.warn("[cloudbase] 缺少 VITE_TCB_ENV_ID / VITE_PUBLISHABLE_KEY，请检查 apps/web/.env.local");
}

export const app = cloudbase.init({
  env,
  region,
  accessKey,
  auth: { detectSessionInUrl: true },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const auth = (app as any).auth;
